export const imagePopulate = {
  populate: {
    imageDesktop: '*',
    imageMobile: '*',
  },
};

export const responsiveVideoPopulate = {
  populate: {
    VideoDesktop: '*',
    VideoMobile: '*',
    PosterImage: imagePopulate,
  },
};

export const blogAuthorPopulate = {
  populate: {
    image: '*',
  },
};

export const blogArticlePopulate = {
  populate: {
    responsiveCoverImage: imagePopulate,
    coverImage: imagePopulate,
    author: blogAuthorPopulate,
    blogTopics: '*',
    introduction: '*',
  },
};
